import CategoryNav from "./CategoryNav";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  BUYER_LOGIN_URL,
  LOGO,
  MSME_CITY,
  MSME_SEARCH,
  SELLER_LOGIN_URL,
} from "../utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import DistrictSelectModal from "./DistrictSelectModal";
import { useDistricts } from "../hooks/useDistricts";
import * as cartActions from "../store/action/cart";
import * as authActions from "../store/action/auth";
import { storeCookie } from "../utils/CookieAction";
import toast from "react-hot-toast";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const place = useLocation();

  const { accessToken, storeCity, storeSearch } = useSelector(
    (state) => state.auth
  );
  const { cartCount } = useSelector((state) => state.cart);

  const [modalOpen, setModalOpen] = useState(false);
  const [location, setLocation] = useState({ label: "", value: "" });
  const [searchText, setSearchText] = useState("");
  const [showClose, setShowClose] = useState(false);

  useDistricts();

  const cartItemCount = useCallback(() => {
    dispatch(cartActions.cartCount());
  }, [dispatch]);

  useEffect(() => {
    cartItemCount();
  }, [cartItemCount]);

  useEffect(() => {
    if (storeCity && storeCity !== location.value) {
      setLocation({ label: storeCity, value: storeCity });
      setModalOpen(false);
    }
  }, [location.value, storeCity]);

  useEffect(() => {
    if (storeCity) {
      setLocation({
        label: storeCity,
        value: storeCity,
      });
    }

    if (place.pathname === "/") {
      setSearchText("");
    } else if (storeSearch) {
      setSearchText(storeSearch);
    } else {
      setSearchText("");
    }
  }, [navigate, place.pathname, storeCity, storeSearch]);

  const handleDistrictSelect = () => {
    setModalOpen(false);
    setShowClose(false);
  };

  const handleSearch = async (e) => {
    e.preventDefault();

    if (storeCity !== location.value) {
      await dispatch(cartActions.cartClean());
    }

    if (location.value && storeCity !== location.value) {
      storeCookie(MSME_CITY, location.value);
      dispatch(authActions.storeCity(location.value));
    }

    if (searchText?.trim()) {
      storeCookie(MSME_SEARCH, searchText);
      dispatch(authActions.storeSearch(searchText));
    }

    const encodedSearch = searchText.trim()
      ? btoa(searchText.trim())
      : btoa("search");
    navigate(`/search-product/${location.value || "city"}/${encodedSearch}`);
  };

  const handleClearSearch = () => {
    setSearchText("");
    storeCookie(MSME_SEARCH, "");
    dispatch(authActions.storeSearch(""));
    if (place.pathname.includes("search-product")) {
      navigate(`/search-product/${location.value || "city"}/${btoa("search")}`);
    }
  };

  const districtOpen = () => {
    setModalOpen(true);
    setShowClose(true);
  };

  useEffect(() => {
    if (!place.pathname.includes("search-product")) {
      storeCookie(MSME_SEARCH, "");
      dispatch(authActions.storeSearch(""));
    }
  }, [dispatch, place.pathname]);

  const signOut = async () => {
    await dispatch(authActions.logout());
    toast.success("Logout successfully");
  };

  return (
    <>
      <DistrictSelectModal
        isOpen={modalOpen}
        onSelect={handleDistrictSelect}
        showClose={showClose}
        setModalOpen={setModalOpen}
      />

      <form onSubmit={handleSearch} className="search-box">
        <button
          type="button"
          className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1"
          onClick={handleClearSearch}>
          <i className="ph ph-x"></i>
        </button>
        <div className="container">
          <div className="position-relative">
            <input
              type="text"
              className="form-control py-16 px-24 text-sm rounded-pill pe-64"
              placeholder="Search Product..."
              required
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            {searchText && (
              <button
                type="button"
                className="w-48 h-48 rounded-circle flex-center text-xl text-gray-500 position-absolute top-50 translate-middle-y inset-inline-end-0 me-16"
                onClick={handleClearSearch}>
                <i className="ph ph-x"></i>
              </button>
            )}
            <button
              type="submit"
              className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8">
              <i className="ph ph-magnifying-glass"></i>
            </button>
          </div>
        </div>
      </form>

      <div className="mobile-menu scroll-sm d-lg-none d-block">
        <button type="button" className="close-button">
          {" "}
          <i className="ph ph-x"></i>{" "}
        </button>
        <div className="mobile-menu__inner">
          <Link to="/" className="mobile-menu__logo">
            <img src={LOGO} alt="Logo" />
          </Link>
          <div className="mobile-menu__menu">
            <ul className="nav-menu flex-align nav-menu--mobile">
              <li className="on-hover-item nav-menu__item activePage">
                <Link to="/" className="nav-menu__link">
                  Home
                </Link>
              </li>
              <li className="on-hover-item nav-menu__item">
                <Link to="/about" className="nav-menu__link">
                  About Us
                </Link>
              </li>
              <li className="on-hover-item nav-menu__item">
                <a href="/buyer" className="nav-menu__link">
                  Buyer
                </a>
              </li>
              <li className="on-hover-item nav-menu__item has-submenu">
                <Link to="#" className="nav-menu__link">
                  Seller
                </Link>
                <ul className="on-hover-dropdown common-dropdown nav-submenu scroll-sm">
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/seller"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100">
                      {" "}
                      Seller Benefits
                    </Link>
                  </li>
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/verified-seller"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100">
                      {" "}
                      Verified Seller
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="on-hover-item nav-menu__item">
                <Link to="#" className="nav-menu__link">
                  Category
                </Link>
              </li>
              <li className="on-hover-item nav-menu__item">
                <Link to="/marketing" className="nav-menu__link">
                  Marketing
                </Link>
              </li>
              <li className="on-hover-item nav-menu__item">
                <Link to="#" className="nav-menu__link">
                  Legal
                </Link>
              </li>
              <li className="on-hover-item nav-menu__item">
                <Link to="#" className="nav-menu__link">
                  Franchise
                </Link>
              </li>
              <li className="on-hover-item nav-menu__item">
                <Link to="/investor" className="nav-menu__link">
                  Investor
                </Link>
              </li>
              <li className="nav-menu__item">
                <Link to="/contact" className="nav-menu__link">
                  Contact Us
                </Link>
              </li>
              <li className="nav-menu__item">
                <Link to="/msme-registration" className="nav-menu__link">
                  Manufacturer Registration
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="header-top bg-main-600 flex-between">
        <div className="container container-lg">
          <div className="flex-between flex-wrap gap-8">
            <ul className="flex-align flex-wrap d-none d-md-flex">
              <li className="border-right-item">
                <Link
                  to="mailto:help@indianmsme.org"
                  className="bg-main-600 text-white h-100 hover-bg-main-800 flex-align gap-8 text-sm d-lg-flex d-none">
                  <div className="d-flex text-20">
                    <i className="ph ph-envelope"></i>
                  </div>
                  help@indianmsme.org
                </Link>
              </li>
              <li className="border-right-item d-flex">
                <Link
                  className="bg-main-600 text-white h-100 hover-bg-main-800 flex-align gap-8 text-sm d-lg-flex d-none"
                  to="tel:8800001259">
                  <div className="d-flex text-20">
                    <i className="ph ph-phone-call"></i>
                  </div>
                  +91-8800001259
                </Link>
                &emsp;
                <Link
                  className="bg-main-600 text-white h-100 hover-bg-main-800 flex-align gap-8 text-sm d-lg-flex d-none"
                  to="tel:9990060509">
                  <div className="d-flex text-20">
                    <i className="ph ph-phone-call"></i>
                  </div>
                  +91-9990060509
                </Link>
              </li>
            </ul>
            <ul className="header-top__right flex-align flex-wrap">
              <li className="on-hover-item border-right-item border-right-item-sm-space">
                <Link
                  to="/ddc-registration"
                  style={{
                    backgroundColor: "#fd6d03",
                    padding: "0px 10px",
                    fontWeight: "700",
                  }}
                  className="text-white text-md py-8">
                  ARDH SAINIK MALL DDC REG
                </Link>
              </li>
              <li className="on-hover-item border-right-item border-right-item-sm-space">
                <Link to="/faq" className="text-white text-sm py-8">
                  FAQ
                </Link>
              </li>

              <li className="border-right-item">
                {accessToken ? (
                  <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                    <a href="#" className="text-white text-sm py-8">
                      My Account
                    </a>
                    <ul className="on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                      <li className="nav-submenu__item">
                        <Link
                          to={BUYER_LOGIN_URL}
                          className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                          target={"_blank"}>
                          <span className="text-sm d-flex">
                            <i className="ph ph-house"></i>
                          </span>
                          Dashboard
                        </Link>
                      </li>
                      <li className="nav-submenu__item">
                        <Link
                          onClick={signOut}
                          to="#"
                          className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0">
                          <span className="text-sm d-flex">
                            <i className="ph ph-sign-out"></i>
                          </span>
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </li>
                ) : (
                  <Link
                    to="/login"
                    className="text-white text-sm py-8 flex-align gap-6">
                    <span className="icon text-md d-flex">
                      {" "}
                      <i className="ph ph-user-circle"></i>{" "}
                    </span>
                    <span className="hover-text-decoration-underline">
                      Buyer Login
                    </span>
                  </Link>
                )}
              </li>
              <li className="border-right-item">
                <Link
                  to={SELLER_LOGIN_URL}
                  className="text-white text-sm py-8 flex-align gap-6"
                  target={"_blank"}>
                  <span className="icon text-md d-flex">
                    {" "}
                    <i className="ph ph-user-circle"></i>{" "}
                  </span>
                  <span className="hover-text-decoration-underline">
                    Manufacturer Login
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <header className="header-middle bg-color-one border-bottom border-gray-100">
        <div className="container container-lg">
          <nav className="header-inner flex-between">
            <div className="logo">
              <Link to="/" className="link">
                <img src={LOGO} alt="Logo" />
              </Link>
            </div>

            <form
              className="flex-align flex-wrap form-location-wrapper"
              onSubmit={handleSearch}>
              <Link to="/verified-seller">
                <div className="location-box bg-success flex-align gap-8 py-6 px-16 rounded-pill border border-gray-100 cursor-pointer">
                  <span className="text-white text-xl d-xs-flex d-none">
                    <i className="ph ph-user-check"></i>{" "}
                  </span>
                  <div className="line-height-1 text-center">
                    <span className="text-white text-xs"> Verified Seller</span>
                  </div>
                </div>
              </Link>
              <div className="search-category d-flex h-48 select-border-end-0 radius-end-0 search-form d-sm-flex d-none">
                <div className="search-form__wrapper position-relative bg-white form-border-radius">
                  <input
                    type="text"
                    className="search-form__input common-input py-13 ps-16 border-0"
                    placeholder="Search Product..."
                    required
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{
                      paddingRight: searchText ? "80px" : "44px",
                      position: "relative",
                      zIndex: 1,
                    }}
                  />
                  {searchText && (
                    <button
                      type="button"
                      className="w-32 h-32 rounded-circle flex-center text-xl text-gray-500 position-absolute top-50 translate-middle-y"
                      onClick={handleClearSearch}
                      style={{
                        right: "48px",
                        zIndex: 2,
                        transform: "translateY(-50%)",
                      }}>
                      <i className="ph ph-x"></i>
                    </button>
                  )}
                  <button
                    type="submit"
                    className="w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y"
                    style={{
                      right: "8px",
                      zIndex: 2,
                      transform: "translateY(-50%)",
                    }}>
                    <i className="ph ph-magnifying-glass"></i>
                  </button>
                </div>
              </div>

              <div
                className="location-box bg-white flex-align gap-8 py-6 px-16 rounded-pill border border-gray-100 cursor-pointer"
                onClick={districtOpen}>
                <span className="text-gray-900 text-xl d-xs-flex d-none">
                  <i className="ph ph-map-pin"></i>
                </span>
                <div className="line-height-1 text-center">
                  <span className="text-gray-600 text-xs">Your District</span>
                  <p className={"text-xs"}>{storeCity}</p>
                </div>
              </div>
            </form>

            <div className="header-right flex-align d-lg-block d-none">
              <div className="flex-align flex-wrap gap-12">
                <button
                  type="button"
                  className="search-icon flex-align d-lg-none d-flex gap-4 item-hover">
                  <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                    <i className="ph ph-magnifying-glass"></i>
                  </span>
                </button>

                <Link to="/cart" className="flex-align gap-4 item-hover">
                  <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                    Cart
                  </span>
                  <span className="text-2xl text-gray-700 d-flex position-relative  mt-6 item-hover__text">
                    <i className="ph ph-shopping-cart-simple"></i>
                    {cartCount > 0 && (
                      <span
                        className="w-20 h-20  flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4"
                        style={{ fontSize: "10px !important" }}>
                        {cartCount}
                      </span>
                    )}
                  </span>
                </Link>
              </div>
            </div>
          </nav>
        </div>
      </header>
      <CategoryNav />
    </>
  );
};

export default Header;
